import React from 'react';
import 'animate.css/animate.min.css';
import ScrollAnimation from 'react-animate-on-scroll';
import { Link } from 'react-router-dom';
import { CWindowWidth } from 'constants/base.const';
import { ERoute } from 'enums/route.enum';
import { Avatar, Tabs, Col, Row, Typography, Button, List } from 'antd';
import { CheckOutlined } from '@ant-design/icons';
import MentoringAboutSource1 from 'assets/images/pages/programAbout/mentee_mentoring_about1.webp';
import MentoringAboutSource2 from 'assets/images/pages/programAbout/mentee_mentoring_about2.webp';
import MentoringAboutSource3 from 'assets/images/pages/programAbout/mentee_mentoring_about3.webp';
import MentoringAboutSource4 from 'assets/images/pages/programAbout/mentee_mentoring_about4.webp';

const { TabPane } = Tabs;
const { Text, Title } = Typography;
const MenteeMentoringAbout = () => {
  return (
    <>
      <div
        style={{
          maxWidth: `${CWindowWidth - 300}px`,
          margin: '80px auto',
          padding: '0px 10px',
        }}
      >
        <Title style={{ marginBottom: '30px' }}>멘토링 방식</Title>
        <Row align='middle' gutter={[32, 16]} justify='space-between' style={{ marginBottom: '120px' }}>
          <Col
            xs={{ span: 24, order: 2 }}
            sm={{ span: 24, order: 2 }}
            md={{ span: 12, order: 1 }}
            lg={{ span: 12, order: 1 }}
            xl={{ span: 12, order: 1 }}
          >
            <ScrollAnimation animateIn='fadeInLeft' animateOnce={true} duration={1.5}>
              <Avatar shape='square' src={MentoringAboutSource1} style={{ height: 'auto', width: '100%' }} />
            </ScrollAnimation>
          </Col>
          <Col
            xs={{ span: 24, order: 1 }}
            sm={{ span: 24, order: 1 }}
            md={{ span: 12, order: 2 }}
            lg={{ span: 12, order: 2 }}
            xl={{ span: 12, order: 2 }}
          >
            <p className='step-info step-right'>
              <span className='step'>STEP 1 </span>
              <Title level={2}>멘토에게 멘토링 신청하기</Title>
              <List split={false}>
                <List.Item.Meta
                  avatar={<CheckOutlined />}
                  description="'멘토보기'에서 마음에 드는 멘토를 찾으세요. 만약 멘토 추천이 필요하면 '문의하기'를 이용해 Career Step과 논의하세요."
                />
                <List.Item.Meta
                  avatar={<CheckOutlined />}
                  description='멘토에 대한 자세한 정보와 멘토링 기능 일정을 확인하세요.'
                />
                <List.Item.Meta
                  avatar={<CheckOutlined />}
                  description='희망 토픽과 요청사항을 적고, 멘토에게 공유하고 싶은 첨부파일을 업로드 하세요.'
                />
                <List.Item.Meta
                  avatar={<CheckOutlined />}
                  description='희망일정을 정하고, 멘토링을 신청하세요.'
                />
              </List>
            </p>
          </Col>
        </Row>
        <Row align='middle' gutter={[32, 16]} justify='space-between' style={{ marginBottom: '120px' }}>
          <Col xs={24} sm={24} md={12} lg={12} xl={12}>
            <p className='step-info step-left'>
              <span className='step'>STEP 2 </span>
              <Title level={2}>멘토링 링크 접속</Title>
              <List split={false}>
                <List.Item.Meta
                  avatar={<CheckOutlined />}
                  description="'나의 멘토링 관리'에서 예정된 멘토링을 확인하세요."
                />
                <List.Item.Meta
                  avatar={<CheckOutlined />}
                  description='일정을 클릭하여 열리는 팝업창에서, 오늘 멘토링 내용을 미리 확인하세요.'
                />
                <List.Item.Meta
                  avatar={<CheckOutlined />}
                  description='팝업창 내 멘토링 참여링크를 눌러 일정을 확인하세요.'
                />
                <List.Item.Meta
                  avatar={<CheckOutlined />}
                  description={
                    <span>
                      멘토링은 Zoom을 통해 화상으로 진행됩니다.
                      <br />(
                      <a target='_blank' href='https://zoom.us/download'>
                        Zoom 다운로드하기
                      </a>
                      )
                    </span>
                  }
                />
              </List>
            </p>
          </Col>
          <Col xs={24} sm={24} md={12} lg={12} xl={12}>
            <ScrollAnimation animateIn='fadeInRight' animateOnce={true} duration={1.5}>
              <Avatar shape='square' src={MentoringAboutSource2} style={{ height: 'auto', width: '100%' }} />
            </ScrollAnimation>
          </Col>
        </Row>
        <Row align='middle' gutter={[32, 16]} justify='space-between' style={{ marginBottom: '120px' }}>
          <Col
            xs={{ span: 24, order: 2 }}
            sm={{ span: 24, order: 2 }}
            md={{ span: 12, order: 1 }}
            lg={{ span: 12, order: 1 }}
            xl={{ span: 12, order: 1 }}
          >
            <ScrollAnimation animateIn='fadeInLeft' animateOnce={true} duration={1.5}>
              <Avatar shape='square' src={MentoringAboutSource3} style={{ height: 'auto', width: '100%' }} />
            </ScrollAnimation>
          </Col>
          <Col
            xs={{ span: 24, order: 1 }}
            sm={{ span: 24, order: 1 }}
            md={{ span: 12, order: 2 }}
            lg={{ span: 12, order: 2 }}
            xl={{ span: 12, order: 2 }}
          >
            <p className='step-info step-right'>
              <span className='step'>STEP 3 </span>
              <Title level={2}>멘토링 진행하기</Title>
              <List split={false}>
                <List.Item.Meta
                  avatar={<CheckOutlined />}
                  description='카메라와 인터넷 연결을 확인하시고, 화상회의 세션에서 멘토를 만나세요.'
                />
                <List.Item.Meta
                  avatar={<CheckOutlined />}
                  description='사전에 전달한 희망 토픽 및 요청사항에 따라 멘토와 멘토링을 진행하세요.'
                />
              </List>
            </p>
          </Col>
        </Row>
        <Row align='middle' gutter={[32, 16]} justify='space-between' style={{ marginBottom: '150px' }}>
          <Col xs={24} sm={24} md={12} lg={12} xl={12}>
            <p className='step-info step-left'>
              <span className='step'>STEP 4 </span>
              <Title level={2}>피드백 확인 및 멘토 피드백 하기</Title>
              <List split={false}>
                <List.Item.Meta
                  avatar={<CheckOutlined />}
                  description="멘토링이 끝나면 멘토가 세심한 피드백을 작성합니다. '나의 멘토링 관리'에서 확인하세요."
                />
                <List.Item.Meta
                  avatar={<CheckOutlined />}
                  description='나에게 도움을 준 멘토에게도 피드백을 해주세요. 간단하게 평점을 주거나, 코멘트를 함께 남겨주세요.'
                />
              </List>
            </p>
          </Col>
          <Col xs={24} sm={24} md={12} lg={12} xl={12}>
            <ScrollAnimation animateIn='fadeInRight' animateOnce={true} duration={1.5}>
              <Avatar shape='square' src={MentoringAboutSource4} style={{ height: 'auto', width: '100%' }} />
            </ScrollAnimation>
          </Col>
        </Row>
      </div>
      <div className='apply-mentoring'>
        <div className='apply-mentoring-content'>
          <Title style={{ color: '#fff' }}>멘토링 신청하기</Title>
          <p style={{ fontSize: 14, color: '#83979F', fontWeight: 'bold' }}>
            커리어 스텝으로 본인이 원하는 커리어를 만들어 보세요!
          </p>
          <Link to={`${ERoute.MentoringMentorList}`}>
            <Button style={{ backgroundColor: '#fff' }} size='large' shape='round'>
              <span style={{ color: '#2A4753', fontWeight: 'bold' }}>멘토링 신청</span>
            </Button>
          </Link>
        </div>
      </div>
    </>
  );
};

export default MenteeMentoringAbout;
